<template>
    <v-container class="width">
        <v-row>
            <v-col cols="12">
                <button class="langbutton float-right my-6"  @click="language"> <p class="margin:3px !important">{{langval}}</p></button>
            </v-col>
        </v-row>
        <div v-if="lang == 'en'">
            <FormulateForm
                name="sp_form"
                v-model="formValues"
                @submit="submitHandler"
                class="login-form">
                <h2 class="form-title">Second Opinion</h2>
                <h4 class="blue">Basic information</h4>
                <div class="double-wide">
                <FormulateInput
                name="name"
                type="text"
                label="Name"
                placeholder="Name"
                validation="required|max:50,length"
                />
                <FormulateInput
                name="sex"
                :options="{Male: 'Male', Female: 'Female', Other: 'Other'}"
                type="select"
                placeholder="Gender"
                label="Gender"
                validation="required"
                />
                </div>
                <div class="double-wide">
                <FormulateInput
                type="date"
                name="birthday"
                label="Birthday"
                placeholder="Birthday"
                validation="required"
                />
                <FormulateInput
                type="text"
                name="place"
                placeholder="Place"
                label="Place"
                validation="required|max:50,length"
                />
                </div>
                <div class="double-wide">
                <FormulateInput
                type="text"
                name="tel"
                placeholder="Telephone"
                label="Telephone"
                />
                <FormulateInput
                type="text"
                name="mobile"
                placeholder="Mobile"
                label="Mobile"
                validation="required|max:20,length"
                />
                </div>
                <FormulateInput
                name="email"
                type="email"
                label="Email address"
                placeholder="Email address"
                validation="required|email|max:30,length"
                />
                <h4 class="blue">Inquiry</h4>
                <div class="double-wide">
                <FormulateInput
                type="text"
                name="department"
                placeholder="Department"
                label="Department"
                validation="required|max:20,length"
                />
                <FormulateInput
                type="text"
                name="hospital"
                placeholder="Hospital"
                label="Hospital"
                validation="required|max:30,length"
                />
                </div>
                <h4 class="blue">Problem Statement</h4>
                <div class="double-wide">
                <FormulateInput
                type="text"
                name="question"
                placeholder="Question"
                label="Question"
                validation="required"
                />
                <FormulateInput
                type="date"
                name="since"
                label="Since"
                placeholder="Since"
                />
                </div>
                <FormulateInput
                type="textarea"
                name="description"
                label="Description"
                placeholder="Description"
                validation="required"
                validation-name="Description"
                />
                <FormulateInput
                type="text"
                name="other"
                label="Other"
                placeholder="Other"
                />
                <FormulateInput
                ignored
                v-model="files"
                type="file"
                @change="showFiles"
                label="Select your documents to upload"
                help="Select one or more files"
                multiple
                />
                <div class="double-wide">
                <FormulateInput
                    name="pw"
                    type="password"
                    label="Password"
                    placeholder="Password"
                    validation="max:15,length"
                />
                <FormulateInput
                type="text"
                name="additionalinformation"
                label="Additional Information"
                placeholder="Additional Information"
                />
                </div>
                    <FormulateInput
                    type="submit"
                    label="Submit"
                    />
            </FormulateForm>
        </div>
        <div v-else>
            <FormulateForm
                name="sp_form"
                v-model="formValues"
                @submit="submitHandler"
                class="login-form"
            >
                <h2 class="form-title">第二个意见</h2>
                <h4 class="blue">基本資料</h4>
                <div class="double-wide">
                <FormulateInput
                name="name"
                type="text"
                label="姓名"
                placeholder="姓名"
                validation="required|max:50,length"
                />
                <FormulateInput
                name="sex"
                :options="{Male: 'Male', Female: 'Female', Other: 'Other'}"
                type="select"
                placeholder="性別"
                label="性別"
                validation="required"
                />
                </div>
                <div class="double-wide">
                <FormulateInput
                type="date"
                name="birthday"
                label="出生年月"
                placeholder="出生年月"
                validation="required"
                />
                <FormulateInput
                type="text"
                name="place"
                placeholder="居住地"
                label="居住地"
                validation="required|max:50,length"
                />
                </div>
                <div class="double-wide">
                <FormulateInput
                type="text"
                name="tel"
                placeholder="聯絡電話"
                label="聯絡電話"
                />
                <FormulateInput
                type="text"
                name="mobile"
                placeholder="手機"
                label="手機"
                validation="required|max:20,length"
                />
                </div>
                <FormulateInput
                name="email"
                type="email"
                label="Email address"
                placeholder="Email address"
                validation="required|email|max:30,length"
                />
                <h4 class="blue">詢問內容</h4>
                <div class="double-wide">
                <FormulateInput
                type="text"
                name="department"
                placeholder="科別"
                label="科別"
                validation="required|max:20,length"
                />
                <FormulateInput
                type="text"
                name="hospital"
                placeholder="看診醫院"
                label="看診醫院"
                validation="required|max:30,length"
                />
                </div>
                <h4 class="blue">問題主述</h4>
                <div class="double-wide">
                <FormulateInput
                type="text"
                name="question"
                placeholder="詢問內容"
                label="詢問內容"
                validation="required"
                />
                <FormulateInput
                type="date"
                name="since"
                label="何時開始"
                placeholder="何時開始"
                />
                </div>
                <FormulateInput
                type="textarea"
                name="description"
                label="病情說明"
                placeholder="病情說明"
                validation="required"
                validation-name="Description"
                />
                <FormulateInput
                type="text"
                name="other"
                label="其他"
                placeholder="其他"
                />
                <FormulateInput
                ignored
                v-model="files"
                type="file"
                @change="showFiles"
                label="檔案"
                multiple
                />
                <div class="double-wide">
                    <!-- <input @click="showFiles" multiple type="file"> -->
                <FormulateInput
                    name="pw"
                    type="password"
                    label="Password"
                    placeholder="Password"
                    validation="max:15,length"
                />
                <FormulateInput
                type="text"
                name="additionalinformation"
                label="補充資訊"
                placeholder="補充資訊"
                />
                </div>
                    <FormulateInput
                    type="submit"
                    label="提交"
                    />
            </FormulateForm>
        </div>
        <v-snackbar v-model="success_snack_en">
            Submitted successfully.
        </v-snackbar>
        <v-snackbar v-model="success_snack_ch">
            提交成功。
        </v-snackbar>
        <v-snackbar v-model="error_snack_en">
            An error occured, please try again.
        </v-snackbar>
        <v-snackbar v-model="error_snack_ch">
            發生錯誤，請重試。
        </v-snackbar>
    </v-container>
</template>
<script>
import axios from 'axios'
export default {
    metaInfo() {
        return { 
            title: "Second opinion"
        }
    },
    data () {
        const lang = localStorage.getItem('lang')
        return {
            formValues:{},
            files:false,
            description:'',
            gender:'',
            lang:lang,
            isIt:false,
            langval:'',
            success_snack_en:false,
            success_snack_ch:false,
            error_snack_en:false,
            error_snack_ch:false,
            items_chinese:['男性','女性','其他'],
        }
    },
    async created(){
        let lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
        if(navigator.language == 'en-US'){
            if(lang =='ch'){
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }else {
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }
        }
        else{
            if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
        }
    },
    methods:{
    language(){
            console.log(this.langval);
            if(this.langval=='EN'){
                localStorage.setItem('lang','en');
                this.langval='中'
            }
            else{
                localStorage.setItem('lang','ch');
                this.langval='EN'
            }
            window.location.reload()
    },
    showFiles(){
        console.log(this.files);
    },
    async submitHandler(){
        this.formValues.file = this.files.fileList;
        let formData = new FormData();
        for (let data in this.formValues) {
            formData.append(data, this.formValues[data]);
        }
        for (const value of formData.values()) {
        console.log(value);
        }
        console.log(this.formValues);
        try {
            const res = await axios.post('secondopinion',formData)
            console.log("submitted succesfully", res.data);
            if(this.langval=='EN'){
                this.success_snack_ch = true;
            }else{
                this.success_snack_en = true;
            }
            this.files =''
            this.$formulate.reset('sp_form')
        } catch (error) {
            this.$formulate.handle(error, 'sp_form')
            if(this.langval=='EN'){
                this.error_snack_ch = true;
            }else{
                this.error_snack_en = true;
            }
            console.log(error, error.response);
        }
    },
    }
}
</script>
<style scoped>
.float-right{
    float:right !important;
}
.blue{
    color: rgb(33, 150, 243);
    margin-bottom: 16px;
}
.my-6{
margin: 12px;
}
.width{
    max-width: 700px;
}
.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  max-width: 700px;
  box-sizing: border-box;
  margin:auto;
}
.form-title {
  margin-bottom: 26px;
}
.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}
@media (min-width: 420px) {
  .double-wide {
    display: flex;
  }
  .double-wide .formulate-input {
    flex-grow: 1;
    width: calc(50% - .5em);
  }
  .double-wide .formulate-input:first-child {
    margin-right: .5em;
  }
  .double-wide .formulate-input:last-child {
    margin-left: .5em;
    margin-bottom: 1.5em !important;
  }
}
</style>